import { EmptyState, STATUSPAGE } from '@repo/ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';

type IDataIndicators = {
  id: string;
  nome: string;
  count: string;
  workload: string;
  foto?: string;
  codigo?: string;
};

interface IProps {
  title: string;
  data?: IDataIndicators[];
  hasCodeColumn?: boolean;
  status?: STATUSPAGE;
  isEffectiveStudentTable?: boolean;
  noDataVariant?: 'default' | 'filter' | 'search' | 'search-x' | 'error';
  noDataTitle?: string;
  noDataDescription?: string;
}

export const CardIndicators = ({
  data,
  title,
  hasCodeColumn = false,
  isEffectiveStudentTable = false,
  status,
  noDataVariant,
  noDataTitle,
  noDataDescription
}: IProps) => {
  return (
    <React.Fragment>
      <Col md={6}>
        <Card>
          <CardHeader>
            <h6 className="fw-semibold">{title}</h6>
          </CardHeader>
          <CardBody>
            {status === STATUSPAGE.LOADING ? (
              <Skeleton
                count={1}
                height={100}
                baseColor="#e8e8e8c5"
                highlightColor="#bababa96"
              />
            ) : (
              <>
                {data?.length > 0 ? (
                  <React.Fragment>
                    <div className="table-responsive table-card">
                      <table className="table align-middle table-borderless table-centered table-nowrap mb-0">
                        <thead className="text-muted table-light">
                          <tr>
                            <th scope="col" style={{ width: '62' }}>
                              Nome
                            </th>
                            <th scope="col">Atividades Realizadas</th>
                            <th scope="col">Carga Horária</th>
                            {hasCodeColumn && <th scope="col">Código</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {(data || []).map((item, index) => (
                            <tr key={index}>
                              <td className="d-flex justify-content-start align-items-start">
                                {isEffectiveStudentTable ? (
                                  <div className="d-flex align-items-center">
                                    {item.foto ? (
                                      <img
                                        src={item.foto}
                                        className="avatar-xs rounded-circle me-2"
                                      />
                                    ) : (
                                      <div
                                        style={{ background: '#144c5b' }}
                                        className="rounded-circle header-profile-user d-flex justify-content-center align-items-center me-2"
                                      >
                                        <i className="text-white ri-user-3-line"></i>
                                      </div>
                                    )}
                                  </div>
                                ) : null}
                                <span
                                  className="mt-2"
                                  style={{
                                    maxWidth: '200px',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  {item.nome}{' '}
                                </span>
                              </td>
                              <td>{item.count}</td>
                              <td>{item.workload}</td>
                              {hasCodeColumn && <td>{item.codigo}</td>}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                ) : (
                  <EmptyState
                    variant={noDataVariant ? noDataVariant : 'default'}
                    title={
                      noDataTitle ? noDataTitle : 'Nenhum registro encontrado'
                    }
                    className="h-100"
                    description={
                      noDataDescription
                        ? noDataDescription
                        : 'Não há dados disponíveis para exibir no momento.'
                    }
                    size={100}
                    paddingY={3}
                  />
                )}
              </>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};
